import { render, staticRenderFns } from "./BrandsItems.vue?vue&type=template&id=62fdedd7&lang=pug"
import script from "./BrandsItems.vue?vue&type=script&lang=js"
export * from "./BrandsItems.vue?vue&type=script&lang=js"
import style0 from "./BrandsItems.vue?vue&type=style&index=0&id=62fdedd7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports